import AppStorage, {StorageKey} from "./AppStorage";

export function getContextParams(overrideParams = {}) {
    const personId = AppStorage.get(StorageKey.PUPIL_ID);
    const schoolYearId = AppStorage.get(StorageKey.SCHOOL_YEAR_ID);

    if (!personId || !schoolYearId) {
        return null;
    }

    const params = {
        "context[personId]": personId,
        "context[schoolYearId]": schoolYearId,
    };

    return { ...params, ...overrideParams };
}

export function getFilterParams(overrideParams = {}) {
    const params = {};
    
    const schoolYearId = AppStorage.get(StorageKey.SCHOOL_YEAR_ID);

    if (!schoolYearId) return null;

    params["filter[schoolYearId]"] = schoolYearId;

    return { ...params, ...overrideParams };
}
